import React from 'react';
import { Typography, Box } from '@mui/material';
import InfoTooltip from './InfoTooltip';
import { ErrorOutline, StarRate } from "@mui/icons-material";
import { useViewMode } from '../contexts/ViewModeContext';

/**
 * RatingSelector component for 1-5 rating scales
 * Displays a row of circular buttons for selecting a rating
 * Updated to match the design with larger circles and consistent styling
 */
const RatingSelector = ({ 
  label, 
  value, 
  onChange, 
  mandatory = false,
  instruction
}) => {
  const ratings = [1, 2, 3, 4, 5];
  const {isViewMode} = useViewMode();

  return (
    <div className="annotation-form-field-container">
      {/* Standardized label */}
      <div className="annotation-form-field-label">
        <span className={`label-text ${mandatory ? 'mandatory' : ''}`}>
          {label}
        </span>
        {mandatory && <span className="required-asterisk">*</span>}
        {instruction && <InfoTooltip instruction={instruction} />}
      </div>
      
      {/* Rating buttons */}
      <div className="annotation-form-field-input">
        <div className="flex justify-start space-x-6" style={{pointerEvents: isViewMode ? "none" : "auto"}} >
          {ratings.map((rating) => (
            <div 
              key={rating} 
              className="flex flex-col items-center"
              onClick={() => onChange(rating)}
            >
              <div 
                className={`w-9 h-9 rounded-full flex items-center justify-center text-lg font-bold cursor-pointer transition-all duration-200 ${
                  value === rating 
                    ? 'bg-black border border-black text-white' 
                    : 'bg-gray-100 border border-gray-300 text-gray-700 hover:bg-gray-200'
                }`}
              >
                {rating}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default RatingSelector;
